// src/services/dataService.js

// Données par défaut pour la démo
const defaultData = {
  displays: [
    {
      id: 'display-1',
      name: 'Écran Principal - Comptoir',
      siteId: 'site-1',
      siteName: 'La Grange des Petits',
      status: 'online',
      resolution: '1920x1080',
      orientation: 'landscape',
      lastHeartbeat: new Date().toISOString(),
      currentTemplate: 'template-1',
      location: 'Comptoir principal',
      ipAddress: '192.168.1.100',
      createdAt: '2025-06-15T10:00:00Z'
    },
    {
      id: 'display-2',
      name: 'Écran Vitrine',
      siteId: 'site-1',
      siteName: 'La Grange des Petits',
      status: 'online',
      resolution: '1080x1920',
      orientation: 'portrait',
      lastHeartbeat: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
      currentTemplate: 'template-1',
      location: 'Vitrine extérieure',
      ipAddress: '192.168.1.101',
      createdAt: '2025-06-14T14:30:00Z'
    },
    {
      id: 'display-3',
      name: 'Écran Terrasse',
      siteId: 'site-1',
      siteName: 'La Grange des Petits',
      status: 'offline',
      resolution: '1920x1080',
      orientation: 'landscape',
      lastHeartbeat: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
      currentTemplate: null,
      location: 'Terrasse',
      ipAddress: '192.168.1.102',
      createdAt: '2025-06-13T16:20:00Z'
    }
  ],

  templates: [
    {
      id: 'template-1',
      name: 'Menu Petit-déjeuner',
      category: 'menu',
      elements: [
        {
          id: 'title-1',
          type: 'text',
          content: 'Les P\'tits dej de la Grange',
          x: 50,
          y: 50,
          fontSize: 48,
          color: '#d4af37',
          fontFamily: 'serif',
          isDynamic: false
        },
        {
          id: 'hours-1',
          type: 'text',
          content: 'DE 6H00 A 11H00 DU LUNDI AU SAMEDI',
          x: 50,
          y: 120,
          fontSize: 18,
          color: '#ffffff',
          fontFamily: 'sans-serif',
          isDynamic: true,
          dynamicTag: 'opening_hours'
        },
        {
          id: 'menu-item-1',
          type: 'text',
          content: 'LE PETIT P\'TIT DEJ',
          x: 50,
          y: 200,
          fontSize: 24,
          color: '#ffffff',
          fontFamily: 'sans-serif',
          isDynamic: false
        },
        {
          id: 'price-1',
          type: 'text',
          content: '2€80',
          x: 400,
          y: 200,
          fontSize: 24,
          color: '#d4af37',
          fontFamily: 'sans-serif',
          isDynamic: true,
          dynamicTag: 'price_petit_dej'
        },
        {
          id: 'menu-item-2',
          type: 'text',
          content: 'LE GRAND P\'TIT DEJ',
          x: 50,
          y: 250,
          fontSize: 24,
          color: '#ffffff',
          fontFamily: 'sans-serif',
          isDynamic: false
        },
        {
          id: 'price-2',
          type: 'text',
          content: '6€50',
          x: 400,
          y: 250,
          fontSize: 24,
          color: '#d4af37',
          fontFamily: 'sans-serif',
          isDynamic: true,
          dynamicTag: 'price_grand_dej'
        }
      ],
      background: {
        type: 'gradient',
        value: 'linear-gradient(135deg, #2d3748 0%, #1a202c 100%)'
      },
      createdAt: '2025-06-15T08:00:00Z',
      updatedAt: '2025-06-20T10:30:00Z'
    }
  ],

  schedules: [
    {
      id: 'schedule-1',
      name: 'Menu Petit-déjeuner',
      description: 'Affichage du menu petit-déjeuner en semaine',
      templateId: 'template-1',
      displayIds: ['display-1', 'display-2'],
      timeRange: '06:00-11:00',
      daysOfWeek: [1, 2, 3, 4, 5, 6], // Lundi à Samedi
      startDate: '2025-06-01',
      endDate: null,
      priority: 1,
      isActive: true,
      tags: {
        'opening_hours': 'DE 6H00 A 11H00 DU LUNDI AU SAMEDI',
        'price_petit_dej': '2€80',
        'price_grand_dej': '6€50'
      },
      createdAt: '2025-06-15T08:00:00Z',
      updatedAt: '2025-06-20T10:30:00Z'
    },
    {
      id: 'schedule-2',
      name: 'Prix Weekend',
      description: 'Prix spéciaux pour le weekend',
      templateId: 'template-1',
      displayIds: ['display-1', 'display-2'],
      timeRange: '06:00-11:00',
      daysOfWeek: [6, 0], // Samedi et Dimanche
      startDate: '2025-06-01',
      endDate: null,
      priority: 2,
      isActive: true,
      tags: {
        'price_petit_dej': '3€20',
        'price_grand_dej': '7€50',
        'special_offer': 'Prix weekend'
      },
      createdAt: '2025-06-16T09:00:00Z',
      updatedAt: '2025-06-20T10:30:00Z'
    }
  ],

  settings: {
    siteName: 'La Grange des Petits',
    timezone: 'Europe/Paris',
    language: 'fr-FR',
    dateFormat: 'DD/MM/YYYY',
    autoSave: true,
    defaultResolution: '1920x1080',
    refreshInterval: 30,
    errorDisplayDuration: 5,
    emailNotifications: true,
    displayOfflineAlert: true,
    contentUpdateAlert: false,
    sessionTimeout: 60,
    requireAuth: true,
    passwordExpiry: 90
  }
};

// Service pour gérer les données dans localStorage
export const loadFromLocalStorage = async (key) => {
  try {
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
    
    // Si pas de données, retourner les données par défaut
    if (defaultData[key]) {
      // Sauvegarder les données par défaut pour la prochaine fois
      await saveToLocalStorage(key, defaultData[key]);
      return defaultData[key];
    }
    
    return [];
  } catch (error) {
    console.error(`Erreur lors du chargement de ${key}:`, error);
    return defaultData[key] || [];
  }
};

export const saveToLocalStorage = async (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error(`Erreur lors de la sauvegarde de ${key}:`, error);
    throw error;
  }
};

export const exportData = () => {
  const data = {
    displays: JSON.parse(localStorage.getItem('displays') || '[]'),
    templates: JSON.parse(localStorage.getItem('templates') || '[]'),
    schedules: JSON.parse(localStorage.getItem('schedules') || '[]'),
    settings: JSON.parse(localStorage.getItem('settings') || '{}'),
    exportDate: new Date().toISOString(),
    version: '1.0.0'
  };
  
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `digital-signage-backup-${Date.now()}.json`;
  a.click();
  URL.revokeObjectURL(url);
};

export const importData = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        
        // Valider la structure des données
        if (!data || typeof data !== 'object') {
          throw new Error('Format de fichier invalide');
        }
        
        // Importer chaque type de données s'il existe
        if (data.displays) {
          localStorage.setItem('displays', JSON.stringify(data.displays));
        }
        
        if (data.templates) {
          localStorage.setItem('templates', JSON.stringify(data.templates));
        }
        
        if (data.schedules) {
          localStorage.setItem('schedules', JSON.stringify(data.schedules));
        }
        
        if (data.settings) {
          localStorage.setItem('settings', JSON.stringify(data.settings));
        }
        
        resolve(data);
      } catch (error) {
        reject(new Error('Erreur lors de l\'importation: ' + error.message));
      }
    };
    
    reader.onerror = () => {
      reject(new Error('Erreur lors de la lecture du fichier'));
    };
    
    reader.readAsText(file);
  });
};

// Utilitaires pour la gestion des données
export const generateId = (prefix = 'item') => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const formatDate = (date, format = 'fr-FR') => {
  return new Date(date).toLocaleDateString(format);
};

export const formatDateTime = (date, format = 'fr-FR') => {
  return new Date(date).toLocaleString(format);
};

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const validateUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

// Nettoyage des données anciennes
export const cleanupOldData = (daysToKeep = 30) => {
  const cutoffDate = new Date();
  cutoffDate.setDate(cutoffDate.getDate() - daysToKeep);
  
  // Ici vous pourriez implémenter la logique de nettoyage
  // par exemple supprimer les logs anciens, les templates non utilisés, etc.
  console.log(`Nettoyage des données antérieures à ${cutoffDate.toISOString()}`);
};

// Statistiques de stockage
export const getStorageStats = () => {
  let totalSize = 0;
  let itemCount = 0;
  
  for (let key in localStorage) {
    if (localStorage.hasOwnProperty(key)) {
      totalSize += localStorage[key].length;
      itemCount++;
    }
  }
  
  return {
    totalSize: Math.round(totalSize / 1024), // en KB
    itemCount,
    displays: JSON.parse(localStorage.getItem('displays') || '[]').length,
    templates: JSON.parse(localStorage.getItem('templates') || '[]').length,
    schedules: JSON.parse(localStorage.getItem('schedules') || '[]').length
  };
};